export const API_BASE_URL = process.env.SUGARTECH_API_URL as string;
export const CDN_BASE_URL = process.env.SUGARTECH_CDN_URL as string;

export const DYNAMIC_TAG_URL = `${API_BASE_URL}/dynamicTag/2/source3`;
export const DYNAMIC_TAG_URL_OLD = `${API_BASE_URL}/dynamicTag/2/source2`;
export const PLANNER_URL = `${CDN_BASE_URL}/planner`;
export const PLANNER_API_URL = `${API_BASE_URL}/planner`;
export const CONFIGURATOR2_URL = `${API_BASE_URL}/configurator2`;
export const CONFIGURATOR2_COMPANY_URL = `${API_BASE_URL}/configurator2/company`;
export const MODULE_VARIANT_PRICE_URL = `${API_BASE_URL}/configurator/module-variant/calculate-price`;

export const PRODUCT_MODEL_URL = `${CDN_BASE_URL}/product/model`;

export const CONFIGURATOR_API_URL = API_BASE_URL;
export const CONFIGURATOR_CDN_URL = CDN_BASE_URL;
